var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUdelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151276",
    "data-name": "Group 151276",
    transform: "translate(-836 -428)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(836 428)",
    fill: "#fff3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_151275",
    "data-name": "Group 151275",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M485.477,450.145h-1a.273.273,0,0,0-.041-.009h-1.064v-.883a.254.254,0,0,0-.248-.253h-2.517a.254.254,0,0,0-.254.253v.883h-1.059a.273.273,0,0,0-.041.009h-1a.254.254,0,0,0,0,.507h.815l.658,6.121a.254.254,0,0,0,.253.227h3.776a.255.255,0,0,0,.249-.227l.658-6.112h.815a.252.252,0,0,0,.219-.127.249.249,0,0,0,0-.253.252.252,0,0,0-.219-.127Zm-4.611-.638h2v.629h-2Zm2.659,6.982h-3.319l-.629-5.828h4.577Z",
    transform: "translate(362 -17.5)",
    fill: "#e41d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M481.865,455.9a.253.253,0,0,0,.18-.074.256.256,0,0,0,.074-.179v-4.135a.253.253,0,1,0-.507,0v4.135a.253.253,0,0,0,.253.253Z",
    transform: "translate(362 -17.5)",
    fill: "#e41d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M480.868,455.894h.01a.253.253,0,0,0,.176-.081.256.256,0,0,0,.067-.181l-.153-4.135h0a.246.246,0,0,0-.08-.178.249.249,0,0,0-.184-.065.255.255,0,0,0-.243.263l.153,4.135a.253.253,0,0,0,.254.242Z",
    transform: "translate(362 -17.5)",
    fill: "#e41d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M482.854,455.894h.009a.256.256,0,0,0,.261-.244l.152-4.135h0a.256.256,0,1,0-.512-.021l-.155,4.134h0a.257.257,0,0,0,.067.185.251.251,0,0,0,.178.081Z",
    transform: "translate(362 -17.5)",
    fill: "#e41d1d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdelete);
export default __webpack_public_path__ + "static/media/udelete.bd4c7b87301f7a93e41ac9a21a0c41fa.svg";
export { ForwardRef as ReactComponent };